// extracted by mini-css-extract-plugin
export var explainable = "_gr-a";
export var printerCard = "_gr-1";
export var printerCardConfigured = "_gr-2";
export var printerCardError = "_gr-3";
export var printerCardsContainer = "_gr-0";
export var printerIcon = "_gr-8";
export var printerIconConfigured = "_gr-5";
export var printerIconContainer = "_gr-4";
export var printerIconError = "_gr-6";
export var printerIconUnconfigured = "_gr-7";
export var workstationsTableCard = "_gr-9";